import React, { FC } from 'react'
import { useLocalization } from '@components/Localization'
import { Text, linkStyles, theme, Box } from '@components/gassan-ui'
import styled from 'styled-components'
import LocalizedLink from '@components/Localization/LocalizedLink'

type Props = {
  size?: string | null
}

const Anchor = styled.a`
  ${linkStyles};
  font-family: ${theme.fonts.body};
  font-size: 0.75rem;
  color: ${theme.colors.shades[500]};
`

const SizeInfo: FC<Props> = ({ size }) => {
  const { lang, messages } = useLocalization()
  return (
    <Box>
      {size === 'dont-know' ? (
        <Text variant="micro" color="shades.500" mb="0" maxWidth="14rem">
          {lang === 'nl'
            ? 'We nemen na de bestelling contact met u op over uw maat'
            : 'We’ll contact you to find your size after purchase'}
        </Text>
      ) : (
        <LocalizedLink href="/[...slug]" as={messages.navigation.determineRingSize}>
          <Anchor target="_blank">{lang === 'nl' ? 'Maat informatie' : 'Size information'}</Anchor>
        </LocalizedLink>
      )}
    </Box>
  )
}

export default SizeInfo
